<div class="terms-conditions">
  <div class="heading">
    <h4>Privacy Policy</h4>
  </div>
  <div class="body">
    <p class="fw6">Effective Date: May 2021</p>

    <p>
      CabScanner and/or its affiliates (collectively “CabScanner”, “we” or “us”) collects information about you when you
      use our mobile applications, websites, call-centre and other products and services (collectively, the “Services”)
      and through other interactions and communications you have with us. This privacy policy sets out the basis on
      which any information, including any personal data, we collect from you, or you provide to us, will be processed
      by CabScanner. Each time you access or use the Services or provide us with information, by doing so you are
      accepting and consenting to the practices described in this privacy policy.
    </p>
    <br>
    <p class="fw6">Scope and Application</p>
    <p>
      This privacy policy (this “privacy policy") applies to persons anywhere in the world who access or use our
      Services (“Users”) as well as to drivers, partner transportation companies, or any other persons who use the
      CabScanner platform under license.
    </p>

    <br>
    <p class="fw6">Collection of Information</p>

    <p>Information You Provide to Us</p>

    <p>
      We collect information you provide directly to us through your access or use of the Services, such as when you
      create or modify your account, request on-demand services, contact customer support, or otherwise communicate with
      us. This information may include: your name, email address, phone number, postal address, profile picture, payment
      method, financial and credit card information, and other information you choose to provide.
    </p>

    <p>
      Please note that we do not knowingly collect, keep or maintain personal information from children under the age of
      18 through the Services, as we require that all users represent to us that they are at least 18 years old.
    </p>

    <p>
      Information We Collect Through Your Use of Our Services
    </p>

    <p>
      When you use our Services, we collect personal information (i.e. information that could be used to contact you
      directly such as full name, postal address, phone number, credit/debit card information, or email address)
      (“Personal Information”) and demographic information (i.e. information that you submit, or that we collect, that
      is not personal information; this may include, but is not limited to, post code, hometown, gender, username,
      device information, including the type of mobile device you use, a unique device identifier (for example, your
      device's IMEI number, the MAC address of the device's wireless network interface, or the mobile phone number used
      by the device), mobile network information, your mobile operating system, the type of mobile browser you use, time
      zone setting, device location, IP address, SMS data, transaction information, age/birth date, browsing history
      information, searching history information, and registration history information) (“Demographic Information” and,
      together with Personal Information, “Personal Data”).
    </p>

    <p>
      We also use GPS technology to determine your current location. Some of our location-enabled Services require your
      personal data for the feature to work. If you wish to use the particular feature, you will be asked to consent to
      your data being used for this purpose.
    </p>
    <p>
      Information We Collect From Other Sources
    </p>
    <p>
      We may also receive information from other sources and combine that with Personal Data we receive from you or
      collect through our Services. For example:
    </p>

    <p>
      If you choose to link, create, or log in to your CabScanner account with a payment provider or social media
      service (e.g., Facebook), or if you engage with a separate app or website that uses our API (or whose API we use),
      we may receive information about you or your connections from that site or app.
      If your employer uses one of our enterprise solutions, we may receive information about you from your employer.
      When you request on demand services, our Drivers may provide us with a User rating after providing services to
      you.
      If you also interact with our Services in another capacity, for instance as a Driver, we may combine or associate
      that information with Personal Data we have collected from you in your capacity as a User or rider.
    </p>

    <br>
    <p class="fw6">
      Use of Personal Data:
    </p>
    <p>
      We may use Personal Data which you provide to us or we collect from you to:

      Provide, maintain, and improve our Services, including, for example, to facilitate payments, send receipts,
      provide products and services you request (and send related information), develop new features, provide customer
      support to Users and Drivers, develop safety features, authenticate users, and send product updates and
      administrative messages.
    </p>
    <p>
      Perform internal administration and operations, including, for example, to prevent fraud and abuse of our
      Services; to troubleshoot software bugs and operational problems; to conduct data analysis, testing, and research;
      and to monitor and analyze usage and activity trends
    </p>
    <p>
      Send or facilitate communications (i) between you and a Driver, such as estimated times of arrival (ETAs), or (ii)
      between you and a contact of yours at your direction in connection with your use of certain features, such as
      referrals or invites
    </p>
    <p>
      Send you communications we think will be of interest to you, including information about products, services,
      promotions, news, and events of CabScanner and other companies, where permissible and according to local
      applicable laws; and to process contest, sweepstake, or other promotion entries and fulfill any related awards;
      Notify you about changes to our Services
    </p>
    <p>
      Allow you to participate in interactive features of our Services;
      Keep our Services safe and secure; and
      Personalize and improve the Services, including to provide or recommend features, content, social connections,
      referrals, and advertisements.
    </p>

    <br>
    <p class="fw6">Storage and Transfer of Personal Data:</p>
    <p>
      You agree that we have the right to transfer the Personal Data described in this privacy policy to and from, and
      process and store it in, countries, some of which may have less protective data protection laws than the region in
      which you reside. Where this is the case, we will take appropriate measures to protect your Personal Data in
      accordance with this privacy policy. By submitting your Personal Data, you agree to this transfer, storing or
      processing. We will take all steps reasonably necessary to ensure your data is treated securely and in accordance
      with this privacy policy.
    </p>
    <p>
      To preserve the integrity of our databases, to carry out on-going Services on your behalf, for research, analytics
      and statistics purposes and to ensure compliance with applicable laws and regulations, we retain Personal
      Information and Demographic Information submitted by Users and Drivers for a reasonable length of time. CabScanner
      is not responsible for the accuracy of the information you provide, and will modify or update your Personal
      Information in our databases upon your request. If required by law or at your request, we will erase or archive
      from active use your Personal Information. By accessing or using the Services, you do hereby represent and warrant
      that you understand that all information submitted by you through the Services or otherwise to CabScanner may be
      used by CabScanner in accordance with applicable laws, this privacy policy and our customer terms of use.
    </p>

    <br>
    <p class="fw6">Sharing of Personal Data</p>
    <p>
      We may share Personal Data which we collect about you as described in this privacy policy or as described at the
      time of collection or sharing, including as follows:
      <br>
      Through Our Services
      <br>
      We may share your Personal Data:
    </p>

    <p>
      With Drivers to enable them to provide the Services you request. For example, we share your name and pickup and/or
      drop-off locations with Drivers;
      With third parties to provide you a service you requested through a partnership or promotional offering made by a
      third party or us;
      With third parties with whom you choose to let us share your Personal Data, for example other apps or websites
      that integrate with our API or Services, or those with an API or Service with which we integrate; and
      With your employer (or similar entity) and any necessary third parties engaged by us or your employer, if you
      participate in any of our enterprise solutions.
      Other Important Sharing
    </p>

    <p>
      We may share your Personal Data;

      With CabScanner subsidiaries and affiliated entities;
      With vendors, consultants, marketing and advertising partners, and other service providers who need access to such
      Personal Data to carry out work on our behalf or to perform any contract we enter into with them;
      In response to a request for information by a competent authority if we believe disclosure is in accordance with,
      or is otherwise required by, any applicable law, regulation, or legal process;
      With law enforcement officials, government authorities, or other third parties to enforce or apply our Terms of
      Service, to investigate potential breaches or if we believe your actions are inconsistent with our Terms of
      Service, or to protect the rights, property, or safety of CabScanner or others;
      With third parties in connection with, or during negotiations of, any merger, sale of company assets,
      consolidation or restructuring, financing, or acquisition of all or a portion of our business by or into another
      company;
    </p>
    <p>
      If we otherwise notify you and you consent to the sharing; With third parties in an aggregated and/or anonymized
      form which cannot reasonably be used to identify you <br>
      Your Choices
    </p>

    <p>Marketing and Opting Out</p>

    <p>
      CabScanner provides Users and Drivers the opportunity to opt-out of receiving communications from us and our
      partners at the point where we request information about the visitor. You have the option to ask us not to process
      your Personal Data for marketing purposes and to remove it from our database, to not receive future communications
      or to no longer receive our Services.
    </p>

    <p>Changes to this Privacy Policy</p>

    <p>
      We may change this privacy policy from time to time. If we make significant changes in the way we treat your
      Personal Data, or to the privacy policy, we will provide you notice through the Services or by some other means,
      such as email. Your continued use of the Services after such notice constitutes your consent to the changes. We
      encourage you to periodically review this privacy policy for the latest information on our privacy practice.
    </p>

    <p>Security Precautions</p>

    <p>Your CabScanner profile is password-protected so that only you and authorized CabScanner employees have access to
      your account information. CabScanner staff will never proactively reach out to you and ask for any personal
      account information, including your password.</p>

    <p>
      CabScanner makes every effort to ensure that your Personal Data is secure on its system. CabScanner has staff
      dedicated to maintaining our privacy policy as set forth herein and other privacy initiatives, periodically
      reviewing Web security and making sure that every CabScanner employee is aware of our security practices.
      Unfortunately, no data transmission over the Internet can be guaranteed to be 100% secure. As a result, CabScanner
      cannot guarantee the security of any Personal Data you transmit to us, and you do so at your own risk. If You have
      any further questions on this issue, refer to our customer terms of use. To the extent permitted by applicable
      law, CabScanner expressly disclaims any liability that may arise should any other individuals obtain the Personal
      Data you submit to CabScanner.
    </p>

    <p>Cookies</p>
    <p>
      Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a
      good experience when you browse our website and also allows us to improve our website and the Services we provide.
      By accessing and browsing our website, you are agreeing to our use of cookies.
    </p>
  </div>
</div>
